<template>
  <v-container fill-height fluid grid-list-xl>
    <material-card
      color="green"
      flat
      full-width
      title="Главная каталога"
    >
      <v-data-table
        loading-text="Загрузка..."
        :headers="headers"
        :items="items"
        :server-items-length="totalCount"
        :options.sync="options"
        :loading="$apollo.queries.GetCatalogLists.loading"
        @refetchData="$apollo.queries.GetCatalogLists.refetch()"
      >
        <template #[`item.photo`]="{ item }">
          <img :src="getImageUrl(item)" style="max-width: 150px;" alt="" />
        </template>
        <template #[`item.href`]="{ item }">
          <a v-if="item.href" :href="item.href" target="_blank">
            {{ item.href }}
          </a>
        </template>
        <template #[`item.status`]="{ item }">
          {{ getStatus(item) }}
        </template>
        <template #[`item.parent`]="{ item }">
          {{ getParentCategory(item) }}
        </template>
        <template #body.prepend>
          <tr>
            <td></td>
            <td></td>
            <td>
              <v-text-field
                v-model="filterTitle"
                clearable
              />
            </td>
            <td>
              <v-select
                v-model="filterParent"
                :items="getParentFilterList()"
                clearable
                item-text="text"
                item-value="id"
                return-object
              />
            </td>
            <td></td>
            <td></td>
            <td>
              <v-select
                v-model="filterStatus"
                :items="statusList"
                clearable
              />
            </td>
            <td></td>
          </tr>
        </template>
        <template #top>
          <v-toolbar flat>
            <v-dialog v-model="dialog">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="red"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Новая запись
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ editedItemId ? "Редактирование" : "Добавление" }}</span>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col sm="8">
                      <v-autocomplete
                        v-model="editParent"
                        :loading="$apollo.queries.GetParentCatalogLists.loading"
                        :items="resultSearchParent || []"
                        label="Родитель"
                        item-text="text"
                        item-value="id"
                        return-object
                        dense
                        hide-no-data
                        :no-data-text="'введите название'"
                        :clearable="true"
                      >
                      </v-autocomplete>
                      <v-text-field
                        v-model="editSort"
                        label="Позиция"
                      />
                      <v-text-field
                        v-model="editTitle"
                        label="Название"
                      />
                      <v-text-field
                        v-model="editHref"
                        label="Ссылка"
                      />
                      или
                      <v-combobox
                        v-model="editCategoryLink"
                        :search-input.sync="searchCategoryLinkText"
                        :loading="$apollo.queries.GetParentCategory.loading"
                        :items="resultSearchCategoryLink || []"
                        label="Категория"
                        item-text="text"
                        item-value="id"
                        return-object
                        dense
                        hide-no-data
                        :no-data-text="'введите название'"
                        :clearable="true"
                      >
                      </v-combobox>
                      <v-select
                        v-model="editStatus"
                        :items="statusList"
                        label="Статус"
                        single-line
                      />
                      <file-input :value="editImage" bucket="image" :single-mode="true" :no-click-url="true" @change="setImage"/>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="close">
                    Отмена
                  </v-btn>
                  <v-btn color="blue darken-1" text @click="save">
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template #item.actions="{ item }">
          <v-icon small class="mr-2" @click="onEditItem(item)">
            mdi-pencil
          </v-icon>
          <v-dialog
            v-model="deleteDialog"
            transition="dialog-bottom-transition"
            width="500"
            @input="onDeleteItem(item)"
          >
            <template #activator="{ on, attrs }">
              <v-tooltip top>
                <template #activator="{ on: tooltipActions, attrs: tooltipAttrs }">
                  <span v-bind="tooltipAttrs" v-on="tooltipActions">
                    <v-icon tag="i" v-bind="attrs" small class="mr-2" v-on="on">
                      mdi-delete
                    </v-icon>
                  </span>
                </template>
                Удалить
              </v-tooltip>
            </template>
            <v-card>
              <v-toolbar color="primary" dark class="text-center mb-6">
                Подтвердите Действие
              </v-toolbar>
              <v-card-text>
                Удалить?
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn color="tertiary" dark @click="deleteDialog = false">
                  Отменить
                </v-btn>
                <v-btn color="primary" @click="deleteItem(item)">
                  Удалить
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import { CreateCatalogList, DeleteCatalogList, GetCatalogLists, UpdateCatalogList } from '@/graphql/catalog-list'
import { getCategory } from '@/graphql/category'
import getDataByName from '@/mixins/getDataByName'
import FileInput from '@/components/articles/FileInput'

export default {
  name: 'CatalogListIndex',
  components: {
    FileInput
  },
  mixins: [getDataByName],
  layout: 'dashboard',
  apollo: {
    GetParentCatalogLists: {
      query: GetCatalogLists,
      variables () {
        return {
          filter: [
            {
              name: 'parent_id',
              value: 'null'
            }
          ],
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      update (data) {
        return data?.GetCatalogLists
      },
      result ({ data }) {
        if (this.resultSearchParent.length === 0) {
          this.resultSearchParent = data.GetCatalogLists.data?.map(v => ({
            id: v.id,
            text: v.title
          }))
        }
      }
    },
    GetCatalogLists: {
      query: GetCatalogLists,
      variables () {
        return this.getQueryVariables()
      },
      result ({ data }) {
        this.items = data.GetCatalogLists.data
        this.totalCount = data.GetCatalogLists.count
      },
      debounce: 300
    },
    GetParentCategory: {
      query: getCategory,
      result ({ data, loading }) {
        this.resultSearchCategoryLink = data?.getCategory?.categores?.map(v => this.newCategoryLinkItem(v.id, v.name, v.slug))
      },
      update: data => data?.getCategory,
      variables () {
        return {
          search: [
            {
              name: 'name',
              value: this.searchCategoryLinkText
            }
          ]
        }
      },
      skip () {
        return !this.searchCategoryLinkText.length
      },
      debounce: 300
    }
  },
  data () {
    return {
      items: [],
      options: {
        page: 1,
        itemsPerPage: 20,
        multiSort: false
      },
      filter: {
        status: ''
      },
      totalCount: 0,
      headers: [
        {
          text: 'Id',
          value: 'id',
          sortable: false
        },
        {
          text: '',
          value: 'photo',
          sortable: false
        },
        {
          text: 'Название',
          value: 'title',
          sortable: false
        },
        {
          text: 'Родитель',
          value: 'parent',
          sortable: false
        },
        {
          text: 'Ссылка',
          value: 'href',
          sortable: false
        },
        {
          text: 'Позиция',
          value: 'sort',
          sortable: false
        },
        {
          text: 'Статус',
          value: 'status',
          sortable: false
        },
        {
          text: '',
          value: 'actions'
        }
      ],
      dialog: false,
      deleteDialog: false,
      dialogCategory: false,
      deleteItemId: null,
      editedItemId: null,
      newItem: true,
      statusList: [
        { value: 'ACTIVE', text: 'Активно' },
        { value: 'NOT_ACTIVE', text: 'Не активно' }
      ],
      statusListConverter: { ACTIVE: 1, NOT_ACTIVE: 2 },
      editTitle: '',
      editSort: '',
      editHref: '',
      editParentId: '',
      editParent: [],
      editCategoryLink: [],
      editImages: [],
      editStatus: '',
      editImage: [],
      searchCategoryLinkText: '',
      resultSearchCategoryLink: [],
      resultSearchParent: [],
      filterTitle: '',
      filterParent: null,
      filterStatus: -1
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    getQueryVariables () {
      return {
        limit: this.options.itemsPerPage,
        offset: this.options.itemsPerPage * (this.options.page - 1),
        filter: this.getFilters()
      }
    },
    getFilters () {
      const filter = []
      if (this.filterStatus !== -1 && this.filterStatus) {
        filter.push({
          name: 'status',
          value: this.filterStatus
        })
      }
      if (this.filterTitle) {
        filter.push({
          name: 'title',
          value: this.filterTitle
        })
      }
      if (this.filterParent?.id) {
        filter.push({
          name: 'parent_id',
          value: this.filterParent.id.toString()
        })
      }

      return filter
    },
    close () {
      this.editTitle = ''
      this.editHref = ''
      this.editSort = ''
      this.editParentId = 0
      this.editedItemId = null
      this.editStatus = ''
      this.editImages = []
      this.dialog = false
      this.resultSearchCategoryLink = []
      this.editCategoryLink = null
      this.editParent = null
      this.editImage = []
    },
    onEditItem (item) {
      if (this.getDataByName(item?.data, 'category_id')) {
        const i = this.newCategoryLinkItem(
            this.getDataByName(item?.data, 'category_id'),
            this.getDataByName(item?.data, 'category_name'),
            this.getDataByName(item?.data, 'category_slug')
        )
        this.resultSearchCategoryLink.push(i)
        this.editCategoryLink = i
      } else {
        this.editHref = item.href
      }
      if (this.getDataByName(item?.data, 'image_key')) {
        this.editImage = [{
          alt: this.getDataByName(item?.data, 'image_alt'),
          file: {
            key: this.getDataByName(item?.data, 'image_key'),
            url: item?.image_url
          }
        }]
      }
      this.editTitle = item.title
      this.editSort = item.sort
      this.editParent = {
        id: item.parent_id
      }
      this.editedItemId = item.id
      // const i = this.statusListConverter.findIndex(v => v === item.status)
      this.editStatus = item.status
      this.dialog = true
    },
    save () {
      const data = []
      if (this.editCategoryLink && this.editCategoryLink?.slug?.length) {
        data.push(...[
          {
            name: 'category_name',
            value: this.editCategoryLink.text
          },
          {
            name: 'category_slug',
            value: this.editCategoryLink.slug
          },
          {
            name: 'category_id',
            value: this.editCategoryLink?.id?.toString()
          }
        ])
        this.editHref = '/catalog/' + this.editCategoryLink.slug
      }
      if (this.editImage && this.editImage.length) {
        data.push(...[
            {
              name: 'image_key',
              value: this.editImage?.at(0)?.file?.key
            },
            {
              name: 'image_alt',
              value: this.editImage?.at(0)?.alt
            }
          ]
        )
      }
      const vars = {
        input: {
          parent_id: this.editParent?.id ?? null,
          title: this.editTitle,
          sort: parseInt(this.editSort),
          href: this.editHref,
          image_url: this.editImage?.at(0)?.file?.url ?? '',
          status: this.statusListConverter[this.editStatus] ?? 0,
          data
        }
      }
      let mutation = CreateCatalogList
      let successText = 'Запись успешно создана'
      if (this.editedItemId) {
        mutation = UpdateCatalogList
        successText = 'Запись успешно обновлена'
        vars.id = this.editedItemId
      }
      this.$apollo
          .mutate({
            mutation,
            variables: vars
          })
          .then((data) => {
            this.$toast.success(successText)
            this.$apollo.queries.GetCatalogLists.refetch()
            this.$apollo.queries.GetParentCatalogLists.refetch()
          })
          .catch((error) => {
            console.error(error)
          }).finally(() => {
            this.close()
          })
    },
    onDeleteItem (item) {
      this.deleteItemId = item.id
      this.deleteDialog = true
    },
    deleteItem () {
      if (!this.deleteItemId) {
        return
      }
        this.$apollo
            .mutate({
              mutation: DeleteCatalogList,
              variables: {
                id: this.deleteItemId
              }
            })
            .then((data) => {
              this.$toast.success('Запись успешно удалена')
              this.$apollo.queries.GetCatalogLists.refetch()
              this.$apollo.queries.GetParentCatalogLists.refetch()
            })
            .catch((error) => {
              this.$toast.error(error)
            })
            .finally(() => {
              this.deleteDialog = false
            })
    },
    getImageUrl (item) {
      return item?.image_url.length > 0 ? 'https:' + item.image_url : ''
    },
    newCategoryLinkItem (id, text, slug) {
      return {
        id,
        text,
        slug
      }
    },
    getStatus (item) {
      const ret = this.statusList.filter(row => row.value === item.status)
      if (ret.length > 0) {
        return ret[0].text
      }

      return item.status
    },
    getParentCategory (item) {
      return item?.parent?.title
    },
    getParentFilterList () {
      return [{ text: 'без родителя', id: 'null' }, ...this.resultSearchParent]
    },
    setImage (val) {
      this.editImage = val
    }
  }
}
</script>

<style scoped>

</style>
